module.exports = __webpack_public_path__ + "static/media/cricket.c139ff02.svg";